import React, { useState } from "react";
import { useMutation, gql } from "@apollo/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp, faThumbsDown } from "@fortawesome/free-solid-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";

const VOTE_UP_DOWN_MUTATION = gql`
  mutation($id: ID!, $upOrDown: String!, $incOrDec: String!) {
    voteProduct(id: $id, upOrDown: $upOrDown, incOrDec: $incOrDec) {
      upCount
      downCount
    }
  }
`;

const UpDownVote = (props) => {
  const { id, isClient } = props;

  const [voteUpDownFunc] = useMutation(VOTE_UP_DOWN_MUTATION);

  const [upVoted, setUpVoted] = useState(() => {
    const voted = isClient ? window.localStorage.getItem(id) : "";
    return voted && voted === "up";
  });
  const [downVoted, setDownVoted] = useState(() => {
    const voted = isClient ? window.localStorage.getItem(id) : "";
    return voted && voted === "down";
  });

  const handleUpVote = (id) => {
    //if upVoted before, cancel
    if (upVoted) {
      setUpVoted(false);
      if (isClient) window.localStorage.setItem(id, "");
      voteUpDownFunc({ variables: { id, upOrDown: "up", incOrDec: "dec" } });
    } else {
      //if NOT voted, or downVoted before
      setUpVoted(true);
      setDownVoted(false);
      if (isClient) window.localStorage.setItem(id, "up");
      voteUpDownFunc({ variables: { id, upOrDown: "up", incOrDec: "inc" } });

      //if downVoted before, revert
      if (downVoted) {
        voteUpDownFunc({
          variables: { id, upOrDown: "down", incOrDec: "dec" },
        });
      }
    }
  };

  const handleDownVote = (id) => {
    //if downVoted before, cancel
    if (downVoted) {
      setDownVoted(false);
      if (isClient) window.localStorage.setItem(id, "");
      voteUpDownFunc({
        variables: { id, upOrDown: "down", incOrDec: "dec" },
      });
    } else {
      //if NOT voted, or upVoted before
      setUpVoted(false);
      setDownVoted(true);
      if (isClient) window.localStorage.setItem(id, "down");
      voteUpDownFunc({
        variables: { id, upOrDown: "down", incOrDec: "inc" },
      });

      //if upVoted before, revert
      if (upVoted) {
        voteUpDownFunc({
          variables: { id, upOrDown: "up", incOrDec: "dec" },
        });
      }
    }
  };

  const style = { cursor: "pointer", fontSize: "1.4rem", marginRight: "10px" };
  const styleVoted = { ...style, color: "#007bff" };
  return (
    <div className="thumb-up-down">
      <span
        className={upVoted ? "voted" : ""}
        style={upVoted ? styleVoted : style}
        onClick={() => handleUpVote(id)}
      >
        <FontAwesomeIcon icon={faThumbsUp} />
      </span>
      <span
        className={downVoted ? "voted" : ""}
        style={downVoted ? styleVoted : style}
        onClick={() => handleDownVote(id)}
      >
        <FontAwesomeIcon icon={faThumbsDown} />
      </span>
    </div>
  );
};

export default UpDownVote;
